import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadMessages() {
  const context = require.context('./locales', true, /[a-z0-9-_]+\.json$/i);

  const messages = context
    .keys()
    .map((key: any) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
    .reduce(
      (mesgs, { key, locale }) => ({
        ...mesgs,
        [locale]: context(key),
      }),
      {}
    );

  return messages;
}

export default function loadI18n() {
  const messages = loadMessages();

  // VueI18n instance
  return new VueI18n({
    locale: 'fr',
    messages,
  });
}
